import { createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../../../service/axiosInstance";

export const fetchDraftProfessorPageContent = createAsyncThunk(
  "draftProfessor/fetchPageContent",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get("draft-professor/page-content/");
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const fetchDraftProfessorPlayers = createAsyncThunk(
  "draftProfessor/fetchPlayers",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get("draft-professor/players/");
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);
